import { render, staticRenderFns } from "./T1SzukajOferty.vue?vue&type=template&id=5439620e&scoped=true&"
import script from "./T1SzukajOferty.vue?vue&type=script&lang=js&"
export * from "./T1SzukajOferty.vue?vue&type=script&lang=js&"
import style0 from "./T1SzukajOferty.vue?vue&type=style&index=0&id=5439620e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439620e",
  null
  
)

export default component.exports